import React from "react";
import {
    AddRounded,
    BuildRounded,
    DeleteRounded,
    EngineeringRounded,
    FactCheckRounded,
    HandymanRounded,
    RemoveRounded,
    SensorsRounded,
    SwapHorizRounded,
} from "@mui-symbols-material/w300";
import { ManualEventType } from "../codegen/graphql";

export const getEventTypeIcon = (type: ManualEventType, sx?: any): React.ReactNode => {
    const iconSx = sx ?? { fontSize: 32, color: '#666' };
    switch (type) {
        case ManualEventType.ASSET_MAINTENANCE: return <BuildRounded sx={iconSx} />;
        case ManualEventType.ASSET_REPAIR: return <HandymanRounded sx={iconSx} />;
        case ManualEventType.ASSET_INSTALL: return <AddRounded sx={iconSx} />;
        case ManualEventType.ASSET_REMOVE: return <RemoveRounded sx={iconSx} />;
        case ManualEventType.ASSET_EXCHANGE: return <SwapHorizRounded sx={iconSx} />;
        case ManualEventType.ASSET_DELETE: return <DeleteRounded sx={iconSx} />;
        case ManualEventType.ASSET_ONSITE_INTERVENTION: return <EngineeringRounded sx={iconSx} />;
        case ManualEventType.ASSET_VACUUM_CHECK: return <FactCheckRounded sx={iconSx} />;
        // IoT commissioning checklist (IBM-1045) — the event type arrived with the IBM-1039 schema regeneration.
        case ManualEventType.ASSET_IOT_COMMISSIONING: return <SensorsRounded sx={iconSx} />;
        default: return null;
    }
};
